export default __webpack_public_path__ + "static/media/imei_label.2028997c.png";